export default __webpack_public_path__ + "static/armony-plus-1-0fcd0511b244373211ec0c1559fe94b4.jpg";